import { useMemo } from "react";
import { BaseEdge, Edge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from "@xyflow/react";
import { KalikoCondition } from "../../../../Core/Api/Types/kaliko";
import { useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { GetDiagramNodes, GetOrientation } from "../../../../Redux/Reducers/redux-slice-workflow-designer";
import { getKalikoStatusColor } from "./utils";
export type KalikoLinkProps = Edge<{ condition: KalikoCondition | null; name: string }, "customEdge">;
export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data,
  target,
  source,
  selected,
  ...props
}: EdgeProps<KalikoLinkProps>) {
  const theme = useTheme();
  const nodes = useSelector(GetDiagramNodes);
  const xEqual = sourceX === targetX;
  const yEqual = sourceY === targetY;
  const targetStatus = nodes.find((x) => x.id === target)?.data.status;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX: xEqual ? sourceX + 0.0001 : sourceX,
    sourceY: yEqual ? sourceY + 0.0001 : sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  //   const [edgePath] = useMemo(
  //     () =>
  //       getBezierPath({
  //         sourceX: xEqual ? sourceX + 0.0001 : sourceX,
  //         sourceY: yEqual ? sourceY + 0.0001 : sourceY,
  //         sourcePosition,
  //         targetX,
  //         targetY,
  //         targetPosition,
  //       }),
  //     [orientation, sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition]
  //   );

  const stroke = useMemo(() => {
    if (selected) return theme.palette.primary.main;
    return getKalikoStatusColor(targetStatus, theme);
  }, [targetStatus, selected, theme.palette.mode]);
  return (
    <>
      <BaseEdge
        labelShowBg
        label={data?.name ?? ""}
        path={edgePath}
        style={{
          ...style,
          stroke,
        }}
        interactionWidth={48}
        {...props}
      />
      {data && data.name && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: "absolute",
              left: labelX - 18,
              top: labelY - 18,
              background: theme.palette.background.paper,
              border: `1px dashed ${selected ? theme.palette.primary.main : theme.palette.background.inverted}`,
              borderRadius: "6px",
              padding: "6px",
            }}
          >
            {data.name}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
